import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { pageWindow } from './album-list';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-pager',
  template: `
    @if (pages() > 1) {
    <nav class="pager" aria-label="Pagination">
      <button type="button" class="pager-btn" [disabled]="page() <= 1" (click)="go(page() - 1)">&lsaquo; Prev</button>
      @for (p of window(); track $index) {
        @if (p === null) {
        <span class="pager-gap">&hellip;</span>
        } @else {
        <button type="button" class="pager-btn" [class.active]="p === page()"
          [attr.aria-current]="p === page() ? 'page' : null" (click)="go(p)">{{p}}</button>
        }
      }
      <button type="button" class="pager-btn" [disabled]="page() >= pages()" (click)="go(page() + 1)">Next &rsaquo;</button>
    </nav>
    }
  `,
  styles: [`
    .pager { display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: 6px; margin: 24px 0; }
    .pager-btn { font: inherit; font-size: 0.85rem; min-width: 34px; padding: 6px 10px; border: 1px solid rgba(0,0,0,.15);
      border-radius: 16px; background: #fff; color: inherit; cursor: pointer; }
    .pager-btn:hover:not(:disabled) { background: rgba(103,58,183,.08); }
    .pager-btn.active { background: #673ab7; border-color: #673ab7; color: #fff; }
    .pager-btn:disabled { opacity: .4; cursor: default; }
    .pager-gap { padding: 0 4px; color: #666; }
  `]
})
export class PagerComponent {
  page = input.required<number>();
  pages = input.required<number>();
  pageChange = output<number>();

  window = computed(() => pageWindow(this.page(), this.pages()));

  go(p: number) {
    if (p >= 1 && p <= this.pages() && p !== this.page()) this.pageChange.emit(p);
  }
}
